<script setup>
import { Link } from '@inertiajs/vue3'
import UserAvatar from './UserAvatar.vue'
import ReputationModal from '../Reputation/ReputationModal.vue'

defineProps({
  user: Object,
})
</script>

<template>
  <div class="flex flex-col overflow-hidden rounded-md bg-white shadow">
    <div class="flex items-center gap-4 px-6 py-4">
      <UserAvatar :user="user" />
      <div>
        <div class="font-medium text-gray-900">
          {{ user.name }}
        </div>

        <div class="text-sm text-gray-500">
          {{ user.rank }}
        </div>
      </div>
    </div>

    <div class="grow border-t px-6 py-4 text-sm">
      <dl class="max-w-sm space-y-2">
        <div v-if="user?.email" class="flex justify-between py-2">
          <dt class="text-base font-medium text-gray-900">Email</dt>
          <dd class="mt-1 text-right text-base leading-6 text-gray-700 sm:mt-0">
            {{ user.email }}
            <Link
              v-if="!$page.props.auth.user.verified && user.id === $page.props.auth.user.id"
              class="text-link underline hover:text-link-hover"
              :href="route('verification.notice')"
            >
              Verify &rarr;
            </Link>
          </dd>
        </div>

        <div class="flex justify-between py-2">
          <dt class="text-base font-medium text-gray-900">
            Reputation
            <ReputationModal trigger-class="inline text-gray-500" />
          </dt>
          <dd class="mt-1 text-right text-base leading-6 text-gray-700 sm:mt-0">
            {{ parseInt(user.reputation).toLocaleString() }}
          </dd>
        </div>

        <div class="flex justify-between py-2">
          <dt class="text-base font-medium text-gray-900">Convict Contributions</dt>
          <dd class="mt-1 text-right text-base leading-6 text-gray-700 sm:mt-0">
            {{ parseInt(user.convict_histories_count).toLocaleString() }}
          </dd>
        </div>

        <div class="flex justify-between py-2">
          <dt class="text-base font-medium text-gray-900">Convict Notes</dt>
          <dd class="mt-1 text-right text-base leading-6 text-gray-700 sm:mt-0">
            {{ parseInt(user.convict_notes_count).toLocaleString() }}
          </dd>
        </div>
      </dl>
    </div>

    <div class="mt-4 flex items-center gap-2 border-t px-6 py-4">
      <slot name="actions" />
    </div>
  </div>
</template>
